<script>
	import { onMount } from 'svelte';
  import { functions } from "./firebase"
  import util from "./util"
  import dayjs from 'dayjs';
  import "dayjs/locale/ja"
  dayjs.locale('ja')

  let newsList = []

  onMount(async () => {
    // localの場合 emulator を使う
    if (!__myapp.env.IS_PROD) {
      functions.useFunctionsEmulator("http://localhost:5001");
    }

    const onCallFetchNewsList = functions.httpsCallable('onCallFetchNewsList');

    onCallFetchNewsList().then(result => {
      newsList = result.data.contents
    }).catch(e => {
      console.log(e)
    })
	});

</script>

{#if newsList.length > 0}
  <div class="section-news__wrapper">
    <div class="section-news__title">
      お知らせ
    </div>
    <div class="section-news__item-list">
      {#each newsList as news}
        <dl class="section-news__item">
          <dt>{dayjs(news.publishedAt).format('YYYY.MM.DD')}</dt>
          <dd>{util.truncate(news.title, 40)}</dd>
        </dl>
      {/each}
    </div>
  </div>
{/if}
